<template>
  <Dialog
    v-model="config.isVisible"
    size="medium"
    position="top"
  >
    <Stack gap="small">
      <Text center color="dark">{{ config.title }}</Text>
      <Text center color="dark">{{ config.message }}</Text>
    </Stack>
    <template #footer>
      <Box marginTop="xsmall" gapX="small" justifyContent="center" full>
        <Button color="purple" @click="config.confirm">{{ config.confirmLabel }}</Button>
        <Button @click="config.cancel">{{ config.cancelLabel }}</Button>
      </Box>
    </template>
  </Dialog>
</template>

<script setup>
import { useConfirmDialog } from '@/composables/useConfirmDialog.js'
import Dialog from './Dialog.vue'
import Button from '@/components/Core/Button.vue'
import { Box, Stack } from '@/components/Core/Layout'
import Text from '@/components/Core/Text.vue'

const { config } = useConfirmDialog()
</script>